module.exports = __webpack_public_path__ + "media/images/kvimg_3sp-022351e857f3164b188af64dcb678741.jpg";